module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('lang.title')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.versionTable,
      "default-expand-all": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('lang.category')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.$t(("lang." + (scope.row.category)))))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(categoryProps) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": categoryProps.row.data
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "expand"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(props) {
              return [_c('el-form', {
                staticClass: "demo-table-expand",
                attrs: {
                  "label-position": "left"
                }
              }, [_c('el-form-item', {
                attrs: {
                  "label": _vm.$t('lang.description')
                }
              }, [_c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(props.row.desc[_vm.$lang]))])]), _vm._v(" "), _c('el-form-item', {
                attrs: {
                  "label": _vm.$t('lang.releaseNote')
                }
              }, [_c('br'), _vm._v(" "), _vm._l((props.row.releaseNote[_vm.$lang]), function(item) {
                return _c('li', [_vm._v(_vm._s(item))])
              })], 2)], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": _vm.$t('lang.name'),
            "prop": "name"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": _vm.$t('lang.version'),
            "prop": "version"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": _vm.$t('lang.updateDate'),
            "prop": "publishDate"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": _vm.$t('lang.download')
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(props) {
              return [_c('el-popover', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (props.row.category === 'software'),
                  expression: "props.row.category === 'software'"
                }],
                ref: "popover4",
                attrs: {
                  "placement": "right",
                  "width": "400",
                  "trigger": "hover"
                }
              }, _vm._l((props.row.url), function(v, k) {
                return _c('li', [_c('a', {
                  attrs: {
                    "href": v
                  }
                }, [_vm._v(_vm._s(k))])])
              })), _vm._v(" "), _c('el-button', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (props.row.category === 'software'),
                  expression: "props.row.category === 'software'"
                }, {
                  name: "popover",
                  rawName: "v-popover:popover4",
                  arg: "popover4"
                }]
              }, [_vm._v(_vm._s(_vm.$t('lang.download')))]), _vm._v(" "), _c('el-button', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: (props.row.category !== 'software'),
                  expression: "props.row.category !== 'software'"
                }],
                on: {
                  "click": function($event) {
                    _vm.openLink(props.row.url)
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('lang.download')))]), _vm._v(" "), _c('el-button', {
                on: {
                  "click": function($event) {
                    _vm.historyDialog = true;
                    _vm.historyTable = _vm.historyInfo[props.row.name]
                  }
                }
              }, [_vm._v(_vm._s(_vm.$t('lang.history')))])]
            }
          }])
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('lang.history'),
      "visible": _vm.historyDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.historyDialog = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.historyTable
    }
  }, [_c('el-table-column', {
    attrs: {
      "property": "publishDate",
      "label": _vm.$t('lang.updateDate'),
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "property": "version",
      "label": _vm.$t('lang.version'),
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lang.download')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-popover', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.category === 'software'),
            expression: "props.row.category === 'software'"
          }],
          ref: "popover5",
          attrs: {
            "placement": "right",
            "width": "400",
            "trigger": "hover"
          }
        }, _vm._l((props.row.url), function(v, k) {
          return _c('li', [_c('a', {
            attrs: {
              "href": v
            }
          }, [_vm._v(_vm._s(k))])])
        })), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.category === 'software'),
            expression: "props.row.category === 'software'"
          }, {
            name: "popover",
            rawName: "v-popover:popover5",
            arg: "popover5"
          }]
        }, [_vm._v(_vm._s(_vm.$t('lang.download')))]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (props.row.category !== 'software'),
            expression: "props.row.category !== 'software'"
          }],
          on: {
            "click": function($event) {
              _vm.openLink(props.row.url)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('lang.download')))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-493a37d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 140
// module chunks = 1